import { render, staticRenderFns } from "./BaseSocialIcon.vue?vue&type=template&id=20509678&scoped=true&"
import script from "./BaseSocialIcon.vue?vue&type=script&lang=js&"
export * from "./BaseSocialIcon.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=20509678&scoped=true&lang=css&"
import style1 from "./BaseSocialIcon.vue?vue&type=style&index=1&id=20509678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20509678",
  null
  
)

export default component.exports